import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["stroke"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var BellAlertIcon = function BellAlertIcon(_ref) {
  var _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? "#000" : _ref$stroke,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    fill: "none",
    viewBox: "0 0 20 20"
  }, rest), {}, {
    children: [/*#__PURE__*/_jsx("g", {
      stroke: stroke,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5",
      clipPath: "url(#clip0_6458_57681)",
      children: /*#__PURE__*/_jsx("path", {
        d: "M17.5 2.917l-.816.544M18.333 7.5h-.815M2.5 2.917l.816.544M1.667 7.5h.815M11.667 16.667a2.084 2.084 0 01-3.334 0M5.312 10.877V8.02a4.688 4.688 0 019.375 0v2.856h-.003l1.075 1.076a1.666 1.666 0 01-1.18 2.844H5.42a1.667 1.667 0 01-1.179-2.844l1.075-1.076"
      })
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_6458_57681",
        children: /*#__PURE__*/_jsx("path", {
          fill: "#fff",
          d: "M0 0H20V20H0z"
        })
      })
    })]
  }));
};
export default /*#__PURE__*/React.memo(BellAlertIcon);